
import { Vue, Component, Prop } from 'vue-property-decorator';

import { GuideEntryFragment } from '@/pages/graphql/queries/GetGuideArticles.query';

import GuideItem from '@/components/editorial/GuideItem.vue';

@Component({
	name: 'GuideFeatured',
	components: { GuideItem },
})
export default class GuideFeatured extends Vue {
	@Prop({ type: Array, required: true }) items!: GuideEntryFragment[];

	get featuredItem() {
		return this.items[0] ?? null;
	}

	get otherItems() {
		return this.items.slice(1);
	}
}
